import styled from 'styled-components';

export const Container = styled.div`
  & > header {
    border: 0;

    & > div {
      padding-left: 0;
    }

    a {
      color: #b8b8b8;

      &.active,
      &:hover {
        color: #ffffff;
      }
    }
  }
`;

export const ContainerBorder = styled.div`
  border-bottom: solid 1px #4b4e53;
`;
